export type ChannelGroup = "首页栏目" | "专题频道" | "内容板块";

export interface Channel {
  slug: string;
  name: string;
  icon: string;
  tone: "primary" | "accent" | "secondary";
  group: ChannelGroup;
  tagline: string;
  description: string;
  highlights: string[];
  position: string;
}

export const channels: Channel[] = [
  {
    slug: "shi-shi-re-dian",
    name: "实时热点",
    icon: "ri-fire-line",
    tone: "primary",
    group: "首页栏目",
    tagline: "正在发生的讨论",
    description:
      "实时热点紧随舆论焦点，筛选当日正在被广泛讨论的话题，用简明的脉络梳理帮读者快速判断信息重点，不被情绪化标题带偏。",
    highlights: ["每日更新", "话题脉络梳理", "多来源交叉比对"],
    position: "首页首屏下方第一栏",
  },
  {
    slug: "re-dian-pai-hang",
    name: "热点排行榜",
    icon: "ri-bar-chart-2-line",
    tone: "primary",
    group: "首页栏目",
    tagline: "按关注度排序",
    description:
      "热点排行榜以阅读、收藏与讨论量为基础生成榜单，直观呈现在过去 24 小时内关注度上升最快的爆料话题，方便热点追踪。",
    highlights: ["24 小时榜", "上升最快榜", "收藏热榜"],
    position: "首页右侧常驻模块",
  },
  {
    slug: "shen-du-diao-cha",
    name: "深度调查",
    icon: "ri-search-eye-line",
    tone: "accent",
    group: "专题频道",
    tagline: "慢一点，看得更清楚",
    description:
      "深度调查是本站投入最多精力的栏目，通常用数周时间走访当事人、查阅公开资料、比对多方说法，还原事件背后的完整链路。",
    highlights: ["长期跟踪", "多方信源", "证据链整理"],
    position: "专题频道第一栏",
  },
  {
    slug: "hang-ye-guan-cha",
    name: "行业观察",
    icon: "ri-line-chart-line",
    tone: "accent",
    group: "专题频道",
    tagline: "看趋势，也看细节",
    description:
      "行业观察关注消费、零售、出行、本地生活等领域的结构性变化，通过公开数据与一线从业者访谈，解释行业正在发生什么。",
    highlights: ["公开数据引用", "从业者访谈", "趋势图解"],
    position: "专题频道第二栏",
  },
  {
    slug: "shi-jian-zhuan-ti",
    name: "事件专题",
    icon: "ri-folders-line",
    tone: "accent",
    group: "专题频道",
    tagline: "一个事件，一条时间线",
    description:
      "事件专题把分散的报道按时间线重新组织，围绕同一事件持续更新进展、回应与后续处理结果，避免读者反复搜索拼接信息。",
    highlights: ["时间线更新", "相关报道合集", "后续进展追踪"],
    position: "专题频道第三栏",
  },
  {
    slug: "xiao-fei-bao-liao",
    name: "消费爆料",
    icon: "ri-shopping-bag-3-line",
    tone: "secondary",
    group: "内容板块",
    tagline: "把消费中的坑说清楚",
    description:
      "消费爆料聚焦预付卡、退换货、保价、延期服务等常见消费场景，整理真实案例与处理路径，帮助读者在遇到同类问题时少走弯路。",
    highlights: ["案例复盘", "处理路径", "条款解读"],
    position: "内容板块入口第一栏",
  },
  {
    slug: "pi-yao-ke-pu",
    name: "辟谣科普",
    icon: "ri-shield-check-line",
    tone: "secondary",
    group: "内容板块",
    tagline: "先求证，再转发",
    description:
      "辟谣科普针对生活中广泛流传的说法进行溯源与求证，区分「有依据」「被夸大」「完全不实」三种情况，并给出可自行核验的方法。",
    highlights: ["说法溯源", "分级结论", "自检方法"],
    position: "内容板块入口第二栏",
  },
  {
    slug: "sheng-huo-jing-shi",
    name: "生活警示",
    icon: "ri-alert-line",
    tone: "secondary",
    group: "内容板块",
    tagline: "替家人多看一眼",
    description:
      "生活警示整理日常中容易被忽视的风险场景，如推销话术、租房纠纷、上门维修等，用清晰的拆解帮读者和家人提前预防。",
    highlights: ["场景拆解", "话术识别", "预防清单"],
    position: "内容板块入口第三栏",
  },
];

export const getChannel = (slug: string): Channel | undefined =>
  channels.find((c) => c.slug === slug);

export const channelGroups: ChannelGroup[] = ["首页栏目", "专题频道", "内容板块"];